import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-update-dialog',
  templateUrl: './update-dialog.component.html',
  styleUrls: ['./update-dialog.component.css']
})
export class UpdateDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<UpdateDialogComponent>
  ) { }

  ngOnInit(): void {
  }

  closeModal() {
    // abrir link de update
    window.open('https://chromewebstore.google.com/detail/haibu-hr-importar-candida/fmfkigcnggfcfoimmpmbdbkkiilhpddc', '_blank');
    this.dialogRef.close();
  }

  cancelModal() {
    this.dialogRef.close();
  }
}
